import React from 'react';
import PropTypes from 'prop-types';

import { MESSENGERS } from '@mssgme/shared';
import { MESSENGER_BRANDS } from '../constants';

import styles from './Brand.module.scss';

const Brand = ({ messenger }) => {
    const { label, logo } = MESSENGER_BRANDS[messenger];

    return (
        <figure className={styles.root}>
            <img className={styles.logo} src={logo} />
            <figcaption className={styles.caption}>{label}</figcaption>
        </figure>
    );
};

Brand.propTypes = {
    messenger: PropTypes.oneOf(MESSENGERS).isRequired,
};

export default Brand;
